document.addEventListener("DOMContentLoaded", () => {
	const blockElements = document.querySelectorAll(".wpopus-parallax-bg-cover");

	blockElements.forEach((blockElement) => {
		let img = blockElement.querySelector(
			".wp-block-cover__image-background, .wp-block-cover__video-background",
		);
		if (!img) return;

		const imgParent = img.parentElement;
		if (!imgParent) return;

		// Scroll-based parallax speed
		const speed = blockElement.getAttribute("data-speed") || 0.5;
		const scrollEffect =
			blockElement.getAttribute("data-scroll-effect") || "true";
		const mouseEffect =
			blockElement.getAttribute("data-mouse-effect") || "true";

		// Scroll-Based Parallax Effect
		const handleScrollParallax = () => {
			if (scrollEffect !== "true") return;

			const imgY = imgParent.getBoundingClientRect().top + window.scrollY;
			const winY = window.scrollY;
			const winH = window.innerHeight;
			const parentH = imgParent.offsetHeight;
			const imgH = img.offsetHeight; // Image height
			const winBottom = winY + winH;

			// Check if the image is in the viewport
			if (winBottom > imgY && winY < imgY + parentH) {
				// Calculate the scroll position percentage
				const imgBottom = (winBottom - imgY) * speed;
				const imgTop = winH + parentH;
				let imgPercent = (imgBottom / imgTop) * 100 + (50 - speed * 50);

				// Prevent the image from exceeding the parent's boundaries
				const maxMove = ((imgH - parentH) / 2) * (100 / imgH); // Max movement before reaching boundaries
				imgPercent = Math.max(50 - maxMove, Math.min(imgPercent, 50 + maxMove));

				// Apply the transformation to the image
				requestAnimationFrame(() => {
					img.dataset.scrollPercent = imgPercent; // Store scroll position
					img.style.transform = `translate(-50%, -${imgPercent}%)`; // Apply parallax effect
				});
			}
		};

		// Mouse Move Parallax Effect (Adds movement instead of overriding scroll)
		const handleMouseMove = (event) => {
			if (mouseEffect !== "true") return;

			const rect = blockElement.getBoundingClientRect();
			const { clientX, clientY } = event;

			// Check if the mouse is inside the parent container
			if (
				clientX < rect.left ||
				clientX > rect.right ||
				clientY < rect.top ||
				clientY > rect.bottom
			) {
				resetMouseParallax();
				return;
			}

			// Normalize cursor position (-1 to 1)
			const xPercent = ((clientX - rect.left) / rect.width - 0.5) * 2;
			const yPercent = ((clientY - rect.top) / rect.height - 0.5) * 2;

			// Controlled movement
			const moveX = xPercent * 15; // Lower value = less movement
			const moveY = yPercent * 15;

			// Use stored scroll position for smooth transition
			const scrollPercent = img.dataset.scrollPercent || "50";

			requestAnimationFrame(() => {
				img.style.transform = `translate(-50%, -${scrollPercent}%) translate(${moveX}px, ${moveY}px)`;
			});
		};

		// Reset image position when mouse leaves
		const resetMouseParallax = () => {
			if (mouseEffect !== "true") return;

			const scrollPercent = img.dataset.scrollPercent || "50";
			requestAnimationFrame(() => {
				img.style.transform = `translate(-50%, -${scrollPercent}%)`;
			});
		};

		// Event Listeners
		window.addEventListener("scroll", handleScrollParallax, { passive: true });
		window.addEventListener("resize", handleScrollParallax);
		blockElement.addEventListener("mousemove", handleMouseMove);
		blockElement.addEventListener("mouseleave", resetMouseParallax);

		// Initial trigger for scroll parallax
		handleScrollParallax();

		// Cleanup function
		const cleanup = () => {
			window.removeEventListener("scroll", handleScrollParallax);
			window.removeEventListener("resize", handleScrollParallax);
			blockElement.removeEventListener("mousemove", handleMouseMove);
			blockElement.removeEventListener("mouseleave", resetMouseParallax);
		};

		return cleanup;
	});
});
